<template>
  <!-- 添加优惠券 -->
  <jd-dialog title="添加发放型外部优惠券" :width="'800'" :visible="isShow" append-to-body @close="addCouponChange">
    <div>
      <jd-tip>
        <div>
          <p>提示：<br /></p>
          <p>
            1、优惠券当前仅支持创建发放型优惠券，无需用户点击领取，通过活动接口直接发放到用户账户，发放型优惠券不存在被转发或恶意分享的风险；
          </p>
          <p>
            2、POP店铺创建活动时可直接按需新建直发放型优惠券，无需提前预创建；自营店铺可直接填写优惠券KEY；
          </p>
          <p style="color: #2768ff; cursor: pointer" @click="toZyCouponTeach">
            自营券配置教程>>
          </p>
        </div>
      </jd-tip>
    </div>
    <div class="add-coupon">
      <!-- 表单 -->
      <div class="form new-input-box" style="margin-top: 20px">
        <el-form :model="formOne" ref="form" label-width="124px">
          <el-form-item label="putKey" required>
            <el-input
              v-model="formOne.putkey"
              style="width: 320px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="优惠券名称" required>
            <el-input
              v-model="formOne.name"
              style="width: 320px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 底部 -->
    <span slot="footer">
      <footer class="foot" v-if="showButton">
        <jd-button style="margin-right: 8px" @click="addCouponChange"
          >取消</jd-button
        >
        <jd-button @click="setCoupon" type="blue">确认</jd-button>
      </footer>
    </span>
  </jd-dialog>
</template>

<script>
import myPopup from "@/components/jhk/myPopup.vue";

import { externalAuto } from "@/api/jhk/integralCenter/couponWriteController.js";

export default {
  props: {
    showButton: {
      type: Boolean,
      default: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  components: {
    myPopup,
  },
  data() {
    return {
      formOne: {},
    };
  },
  methods: {
    toZyCouponTeach() {
      window.open(
        "https://www.yuque.com/yunduanxincrm/flgan6/mn0f6wect45lxa9v",
        "_blank"
      );
    },

    addCouponChange() {
      this.$emit("close", false);
      this.formOne.name = "";
      this.formOne.putkey = "";
    },
    setCoupon() {
      if (!this.formOne.putkey) return this.$message.warning("请输入putKey");
      if (!this.formOne.name) return this.$message.warning("请输入优惠券名称");
      externalAuto(this.formOne).then((res) => {
        if (res && res.code == 1) {
          this.$message.success(res.message);
          this.addCouponChange(); //关闭弹窗
          setTimeout(() => {
            this.$emit("funcMes");
          }, 800);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-coupon {
  .navTab {
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 35px;
    margin: 20px 0;
    span {
      flex-shrink: 0;
      width: 106px;
      height: 35px;
      line-height: 34px;
      text-align: center;
      margin-right: 2px;
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 2px 2px 0px 0px;
      cursor: pointer;
      &:last-child {
        margin: 0;
      }
    }
    .active {
      border-bottom: none !important;
      border-top: 2px solid #fe4d45;
      border-radius: 4px 4px 0px 0px;
    }
    .line {
      flex: 1;
      border-bottom: 1px solid #ddd;
    }
  }
  .form {
    font-size: 14px;
    color: #333;
    .txt {
      margin-left: 10px;
      color: #999;
    }
  }
  .foot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 30px;
    .cancel {
      width: 98px;
      height: 32px;
      line-height: 28px;
      // margin-right: 12px;
      // border: 1px solid #ccc;
      // color: #999;
    }
    .confirm {
      width: 98px;
      height: 32px;
      line-height: 28px;
      // background-color: #fe4d45;
      // color: #fff;
    }
  }
  button {
    // border: none;
    // background-color: white;
    // outline: none;
    // cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s;
  }
}

.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 12px 0px 12px 20px;
  // display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 26px;
      font-size: 14px;
      color: #333333;
      margin-left: 28px;
    }
  }
}
</style>
